import React, { ReactNode } from 'react';
import ButtonPromptWrapper from '../ButtonPromptWrapper';
import { Video } from '../../../utils/api/videoApi';
import { Color } from '../../../utils/styleguide';
import PrimaryButton from '../buttons/PrimaryButton';
import HeadlinerVideo from '../HeadlinerVideo';
import VideoPlayButton from '../VideoPlayButton';

type HeadlinerVideoSectionProps = {
  title?: ReactNode;
  description?: ReactNode;
  descriptionColor?: Color;
  CTAText?: string;
  CTAPrompt?: string;
  portraitVideo?: Video;
  landscapeVideo?: Video;
  portraitBackgroundVideo: Video;
  landscapeBackgroundVideo: Video;
  href?: string;
};

const HeadlinerVideoSection = ({
  title,
  description,
  CTAText,
  CTAPrompt,
  portraitVideo,
  landscapeVideo,
  portraitBackgroundVideo,
  landscapeBackgroundVideo,
  href,
}: HeadlinerVideoSectionProps) => {
  let button;

  if (portraitVideo || landscapeVideo) {
    button = (
      <VideoPlayButton
        portraitVideo={portraitVideo}
        landscapeVideo={landscapeVideo}
        buttonLabel={CTAText}
      />
    );
  } else if (href) {
    button = (
      <ButtonPromptWrapper prompt={CTAPrompt}>
        <PrimaryButton externalLink href={href} color={'onLight'}>
          {CTAText || 'Learn more'}
        </PrimaryButton>
      </ButtonPromptWrapper>
    );
  }

  return (
    <HeadlinerVideo
      Title={title}
      Description={description}
      Button={button}
      portraitBackgroundVideo={portraitBackgroundVideo}
      landscapeBackgroundVideo={landscapeBackgroundVideo}
    />
  );
};

export default HeadlinerVideoSection;
